import { Reveal } from "@/components/Reveal";
import { BadgeCheck } from "lucide-react";

const APP_URL = "https://app.primeconnect.network";

const BENEFITS = [
  {
    title: "Six months free membership",
    body: "Founding members pay nothing for their first six months on the network.",
  },
  {
    title: "Founding badge in-app",
    body: "A permanent badge on your profile, marking you as one of the very first members.",
  },
  {
    title: "Exclusive events",
    body: "Invitations to private founding-member events and roundtables.",
  },
];

export const FoundingMembers = () => (
  <section
    id="founding-cohort"
    data-testid="founding-cohort-section"
    className="py-24 sm:py-28 bg-[#F3F1EB] border-y border-[#E7E4DC]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
      <Reveal>
        <p className="font-eyebrow text-[11px] text-[#928E84]">Founding cohort &middot; 2026</p>
        <h2 className="font-display font-medium tracking-tight text-[#141518] text-4xl sm:text-5xl mt-5 leading-[1.08] max-w-2xl mx-auto">
          Join the founding cohort now
        </h2>
        <p className="text-base text-[#635F57] leading-relaxed mt-6 max-w-xl mx-auto">
          We are admitting a limited founding cohort of prime agents worldwide.
          Places are reviewed as they arrive.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-3 gap-6 max-w-5xl mx-auto text-left">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1}>
            <div
              data-testid={`founding-benefit-${i}`}
              className="h-full bg-white border border-[#E7E4DC] rounded-3xl p-8"
            >
              <BadgeCheck size={18} className="text-[#B89B6C]" strokeWidth={1.5} />
              <h3 className="font-display text-2xl text-[#141518] mt-5">{b.title}</h3>
              <p className="text-sm text-[#635F57] leading-relaxed mt-3">{b.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <a
          href={APP_URL}
          data-testid="founding-join-btn"
          className="mt-12 inline-flex items-center rounded-full bg-[#141518] text-white text-sm font-medium px-9 py-4 hover:bg-[#26282E] hover:-translate-y-0.5 transition-all duration-300"
        >
          Join PrimeConnect
        </a>
      </Reveal>
    </div>
  </section>
);
